module.exports = __webpack_public_path__ + "31a51c3205e6ee029e789dc2bc3ea2bb.png";